// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sc-user-input--emoji-icon-wrapper[data-v-1a7c780e]{display:block;background:none;border:none;padding:0;margin:0;outline:none}.sc-user-input--emoji-icon-wrapper[data-v-1a7c780e]:focus{outline:none}.sc-user-input--emoji-icon[data-v-1a7c780e]{display:block;cursor:pointer}", ""]);
// Exports
module.exports = exports;
